import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline, sfSub } from './sectionHelpers';

interface Badge {
  image_url?: string;
  label?: string;
  url?: string;
}

const AwardsBadges: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const badges = (c.badges || []) as Badge[];
  const bg = (c.background as string) || 'white';
  const variant = (c.variant as string) || 'grid';

  const bgStyle: React.CSSProperties = { padding: '60px 24px' };
  if (bg === 'primary') {
    bgStyle.background = 'var(--brand-primary, #1a365d)';
    bgStyle.color = '#fff';
  } else if (bg === 'alt') {
    bgStyle.background = 'var(--brand-bg-alt, #f8fafc)';
  } else {
    bgStyle.background = '#fff';
  }

  const headlineColor = bg === 'primary' ? '#fff' : 'inherit';
  const subColor = bg === 'primary' ? 'rgba(255,255,255,0.75)' : '#64748b';
  const labelColor = bg === 'primary' ? 'rgba(255,255,255,0.8)' : '#64748b';

  const gridStyle: React.CSSProperties = variant === 'inline'
    ? { display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 24 }
    : { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 24, maxWidth: 800, margin: '0 auto' };

  return (
    <section className="sb-render sb-render-awards-badges" style={bgStyle}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <InlineEditText
          tag="h2"
          controlKey="headline"
          style={{ textAlign: 'center', marginBottom: 8, color: headlineColor }}
        >
          {sfHeadline(c, 'Awards & Accreditations')}
        </InlineEditText>
        {(sfSub(c) !== undefined) && (
          <InlineEditText
            tag="p"
            controlKey="subheadline"
            style={{ textAlign: 'center', color: subColor, marginBottom: 32 }}
          >
            {sfSub(c, '')}
          </InlineEditText>
        )}
        <div style={gridStyle}>
          {badges.map((badge, i) => {
            const inner = (
              <>
                {badge.image_url && (
                  <img
                    src={badge.image_url}
                    alt={badge.label || ''}
                    style={{ height: 64, objectFit: 'contain', marginBottom: badge.label ? 8 : 0 }}
                  />
                )}
                {badge.label && (
                  <span style={{
                    fontSize: '0.8rem', fontWeight: 600,
                    color: labelColor, textAlign: 'center',
                  }}>
                    {badge.label}
                  </span>
                )}
              </>
            );
            const wrapStyle: React.CSSProperties = {
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 4,
              textDecoration: 'none',
            };
            return badge.url ? (
              <a key={i} href={badge.url} target="_blank" rel="noopener noreferrer" style={wrapStyle}>
                {inner}
              </a>
            ) : (
              <div key={i} style={wrapStyle}>{inner}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AwardsBadges;
